import React from 'react';

import NotFoundPage from 'shared/ui/ErrorPage/NotFoundPage';

const NotFound = () => {
    return  <NotFoundPage/>;
};

export default NotFound;